export default __webpack_public_path__ + "static/media/breakfast-overlay@2x.1e26fc40.png";